export default __webpack_public_path__ + "static/media/640_dummy2016-hilfsprojekt01-de.6614a516.png";